import React, { useContext, useState, useEffect } from 'react';
import { dbPost } from '../../apis/commonApi';
import { GlobalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';

const SubList = () => {
  useEffect(() => {
        document.title = '구독 목록';
      }, []);


  const { store } = useContext(GlobalContext);
  const [subList, setSubList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const fetchData = async () => {
    try {
      const url = '/pay/sub/list.do';
      const response = await dbPost(url, { entSn: store?.entSn });
      setSubList(response);
    } catch (error) {
      setSubList([]);
    }
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return subList.slice(startIndex, startIndex + itemsPerPage);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="contents">
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">납부현황</h2>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">결제 내역</h3>
        <table className="tbl col data scroll">
          <caption>구독 목록을 확인할 수 있는 테이블입니다.</caption>
          <thead>
            <tr>
              <th scope="col">결제승인번호</th>
              <th scope="col">결제승인일시</th>
              <th scope="col">결제금액</th>
              <th scope="col">결제수단</th>
              <th scope="col">성공여부</th>
            </tr>
          </thead>
          <tbody>
            {subList.length > 0 ? (
              paginatedData().map(
                ({ stlmAprvNo, stlmAprvDt, stlmAmt, idntfNm, scsYn }) => (
                  <tr key={stlmAprvNo}>
                    <td>{stlmAprvNo}</td>
                    <td>{stlmAprvDt}</td>
                    <td>{stlmAmt.toLocaleString()} 원</td>
                    <td>{idntfNm}</td>
                    <td>{scsYn === 'Y' ? '성공' : '실패'}</td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center' }}>
                  결제 내역이 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <GbitTablePaging
        totalItems={subList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default SubList;
